var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('menu-hmi',{on:{"seleccion":_vm.seleccion}}),(_vm.elegido==0)?_c('hmi-secadero'):_vm._e(),(_vm.elegido==1)?_c('hmi-principal',{attrs:{"datos":this.datos.main},on:{"cambio_auto_man":_vm.cambio_auto_man}}):_vm._e(),(_vm.elegido==2)?_c('hmi-reguladores'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }